import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { Paintbrush, Building2, Lamp, Layers, Ruler, Hammer, Home as HomeIcon, Sparkles, Building, KeyRound, HardHat } from "lucide-react";
import { Reveal, spotlight } from "@/components/Reveal";
import Marquee from "@/components/Marquee";
import { SERVICE_CATEGORIES } from "@/lib/services";

const ICONS = { Paintbrush, Building2, Lamp, Layers, Ruler, Hammer, Home: HomeIcon, Sparkles, Building, KeyRound, HardHat };

export default function Services() {
    return (
        <div data-testid="services-page" className="pt-28 lg:pt-36">
            <section className="mx-auto max-w-7xl px-4 sm:px-8 lg:px-16">
                <Reveal>
                    <p className="font-mono text-xs uppercase tracking-[0.3em] text-gold">Services</p>
                    <h1 className="font-display mt-5 max-w-3xl text-4xl font-extrabold tracking-tight sm:text-5xl lg:text-6xl">
                        Painting services for <span className="text-gold">every kind of project.</span>
                    </h1>
                    <p className="mt-6 max-w-2xl text-base leading-relaxed text-slate-300">
                        From single rooms to full subdivisions — residential, commercial, new
                        construction and subcontract packages for general contractors across the
                        Greater Toronto Area.
                    </p>
                </Reveal>

                <Reveal delay={0.1}>
                    <p data-testid="services-pricing-note" className="placeholder-block mt-10 p-5 text-xs leading-relaxed text-slate-300">
                        <span className="font-mono uppercase tracking-[0.2em] text-gold">About pricing — </span>
                        Exact pricing depends on project scope, surface condition, preparation
                        required, and selected paint materials. Every quote is free, written, and
                        itemized. We never publish made-up prices.
                    </p>
                </Reveal>

                <div className="mt-14 grid gap-6 pb-8 md:grid-cols-2">
                    {SERVICE_CATEGORIES.map((s, i) => {
                        const Icon = ICONS[s.icon];
                        return (
                            <Reveal key={s.name} delay={(i % 2) * 0.08}>
                                <article data-testid={`service-card-${i}`} onMouseMove={spotlight}
                                    className="spot-card flex h-full flex-col border border-gold/15 bg-ink-3 p-8 transition-colors hover:border-gold/50">
                                    <div className="flex items-center justify-between">
                                        <span className="flex h-11 w-11 items-center justify-center border border-gold/40 bg-gold/10 text-gold">
                                            <Icon size={19} />
                                        </span>
                                        <span className="font-mono text-xs text-slate-600">{String(i + 1).padStart(2, "0")}</span>
                                    </div>
                                    <h2 className="font-display mt-6 text-xl font-bold sm:text-2xl">{s.name}</h2>
                                    <p className="mt-3 text-sm leading-relaxed text-slate-400">{s.desc}</p>
                                    <ul className="mt-5 flex-1 space-y-2.5">
                                        {s.bullets.map((b) => (
                                            <li key={b} className="flex items-start gap-2.5 text-sm text-slate-300">
                                                <span className="mt-1.5 h-1.5 w-1.5 shrink-0 bg-gold" style={{ clipPath: "polygon(50% 0,100% 50%,50% 100%,0 50%)" }} />
                                                {b}
                                            </li>
                                        ))}
                                    </ul>
                                    <Link to={`/contact?service=${encodeURIComponent(s.name)}`}
                                        data-testid={`service-quote-button-${i}`}
                                        className="group mt-8 inline-flex items-center gap-2 border border-gold/40 px-5 py-3 font-mono text-xs uppercase tracking-[0.18em] text-gold transition-colors hover:bg-gold hover:text-ink">
                                        Request quote for this category
                                        <ArrowRight size={13} className="transition-transform group-hover:translate-x-1" />
                                    </Link>
                                </article>
                            </Reveal>
                        );
                    })}
                </div>
            </section>
            <div className="mt-10">
                <Marquee />
            </div>
        </div>
    );
}